module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('h1', {
    staticClass: "plm_hd"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PTOP_contents"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("1QS – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Serek Hayaÿad")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rule of the Community ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("AB – Anchor Bible")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ABD")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anchor Bible Dictionary")]), _vm._v(", ed. D. N. Freedman, 6 vols., New Haven: Yale University Press, 1992")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ABRL – Anchor Bible Reference Library")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ACCS – Ancient Christian Commentary on Scripture")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("AnBib"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" – ")]), _vm._v("Analecta biblica")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ANE – ancient Near East(ern)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ANET")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ancient Near Eastern Texts Relating to the Old Testament")]), _vm._v(", ed. J. B. Pritchard, 3rd edn with supplement, Princeton: Princeton University Press, 1969")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ANTZ"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" – ")]), _vm._v("Arbeiten zur neutestamentlichen Theologie und Zeitgeschichte")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("AOTC – Apollos Old Testament Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Aram. – Aramaic")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ARM")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Archives royales de Mari ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("AS – Aramaic Studies ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("AUSDDS – Andrews University Seminary Doctoral Dissertation Series")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("AUSS – Andrews University Seminary Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BBR – Bulletin for Biblical Research ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BECNT – Baker Exegetical Commentary on the New Testament")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BETL – Bibliotheca ephemeridum theologicarum lovaniensium")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BHS")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Biblia Hebraica Stuttgartensia")]), _vm._v(", ed. K. Elliger and W. Rudoph, Stuttgart: Deutsche Bibelgesellschaft, 1967–77")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bib – Biblica ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BibInt – Biblical Interpretation ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BSac – Bibliotheca sacra ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BRev – Bible Review ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BST – The Bible Speaks Today")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BTB – Biblical Theology Bulletin ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BTCB – Brazos Theological Commentary on the Bible")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BTCP – Biblical Theology of Christian Proclamation")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BYU – Brigham Young University")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BZ – Biblische Zeitschrift ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CBQ – Catholic Biblical Quarterly ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("CBQMS – Catholic Biblical Quarterly Monograph Series")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CBR – Currents in Biblical Research ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("CC – Calvin’s Commentaries")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CTJ – Calvin Theological Journal ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CTR – Criswell Theological Review ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("DOTP – Dictionary of the Old Testament Pentateuch")]), _vm._v(", ed. T. D. Alexander and D. Baker, ﻿Leicester: Inter-Varsity Press; Downers Grove: InterVarsity Press,﻿ ﻿2003")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("EDBT")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Evangelical Dictionary of Biblical Theology")]), _vm._v(", ed. W. A. Elwell, Grand Rapids: Baker, 1996")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("EJ – Encyclopaedia Judaica")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ESEC – Emory Studies in Early Christianity")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ETL – Ephemerides theologicae lovanienses ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("EvQ – Evangelical Quarterly ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ExpTim – Expository Times")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("FAT – Forschungen zum Alten Testament")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("FRLANT – Forschungen zur Religion und Literatur des Alten und Neuen Testaments")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("HBT – Horizons in Biblical Theology ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Hebr. – Hebrew")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("HDR – Harvard Dissertations in Religion")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("HSMM – Harvard Semitic Museum Monographs")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("﻿HTKNT – Herders theologischer Kommentar zum Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ICC – International Critical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Int – Interpretation ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL – Journal of Biblical Literature ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("JBLMS – Journal of Biblical Literature Monograph Series")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JBQ – Jewish Bible Quarterly ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JETS – Journal of the Evangelical Theological Society ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JSNT – Journal for the Study of the New Testament ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("JSNTSup – Journal for the Study of the New Testament Supplement Series")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JSOT – Journal for the Study of the Old Testament ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("JSOTSup – Journal for the Study of the Old Testament Supplement Series")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JSP – Journal for the Study of the Pseudepigrapha ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JTI – Journal of Theological Interpretation ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JTS – Journal of Theological Studies ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("LHBOTS – Library of Hebrew Bible/Old Testament Studies")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("LNTS – Library of New Testament Studies")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("LTJ – Lutheran Theological Journal ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("lxx")]), _vm._v(" – Septuagint")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("m. – masculine")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("MTh – Modern Theology ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NAC – New American Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NCBC – New Cambridge Bible Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NDBT – New Dictionary of Biblical Theology")]), _vm._v(", ed. T. D. Alexander, B. Rosner, D. A. Carson and G. Goldsworthy, Leicester: Inter-Varsity Press; Downers Grove: InterVarsity Press, 2000")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Neot – Neotestamentica ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NICOT – New International Commentary on the Old Testament")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NIDOTTE – New International Dictionary of Old Testament Theology and Exegesis")]), _vm._v(", ed. W. VanGemeren, 5 vols., Grand Rapids: Zondervan, 1997")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NIGTC – New International Greek Text Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NovT – Novum Testamentum ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NSBT – New Studies in Biblical Theology")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("OBO – Orbis biblicus et orientalis")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("OTE – Old Testament Essays ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("OTL – Old Testament Library")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("PBM – Paternoster Biblical Monographs")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("PCNT – Paideia Commentaries on the New Testament")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("PNTC – Pillar New Testament Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("RB – Revue biblique ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("RBJ – Review of Rabbinic Judaism﻿ ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("RBL – Review of Biblical Literature ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ResQ – Restoration Quarterly")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("RTR – Reformed Theological Review ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SANT – Studien zum Alten und Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SB – Subsidia biblica")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SBJT – Southern Baptist Journal of Theology ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SBLDS – Society of Biblical Literature Dissertation Series")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SBLSCS – Society of Biblical Literature Septuagint and Cognate Studies")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SBLSS – Society of Biblical Literature Semeia Studies")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SBS – Stuttgarter Bibelstudien")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SBT – Studies in Biblical Theology")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("sg. – singular")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ScrTh – Scripta theologica ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SJOT – Scandinavian Journal of the Old Testament ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SNTSMS – Society for New Testament Studies Monograph Series")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SP – Sacra pagina")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("STR – Southeastern Theological Review ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("TD")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Theology Digest ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Them – Themelios")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("TJ – Trinity Journal ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("TNTC – Tyndale New Testament Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("TOTC – Tyndale Old Testament Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("TynBul – Tyndale Bulletin ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("VT – Vetus Testamentum ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("VTSup – Vetus Testamentum Supplements")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("WBC – Word Biblical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("WMANT – Wissenschaftliche Monographien zum Alten und Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("WTJ – Westminster Theological Journal ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("WUNT – Wissenschaftliche Untersuchungen zum Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ZAH – Zeitschrift für Althebräistik ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ZAW")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ZECNT – Zondervan Exegetical Commentary on the New Testament")]), _vm._v(" "), _c('p', {
    staticClass: "fo"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13bc6f6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/PTOP_abbrev.vue
// module id = 72
// module chunks = 0